import React from 'react';
import { FadeIn } from './FadeIn';
export function Transformation() {
  const steps = [{
    num: '01',
    title: 'El lunes a la mañana',
    text: 'Arrancás sabiendo exactamente qué vas a trabajar. No porque lo pensaste el domingo a las 11 de la noche buscando en YouTube. Sino porque tenés un sistema con la lógica de progresión ya resuelta y cada sesión tiene un propósito dentro del bloque.'
  }, {
    num: '02',
    title: 'Al terminar cada sesión',
    text: 'Registrás tu entrenamiento en 3 minutos. Carga, RPE, sensación, progreso. Ese registro acumulado semana a semana se convierte después en la evidencia más clara de que el sistema está funcionando y de que vos estás avanzando.'
  }, {
    num: '03',
    title: 'Al final del bloque',
    text: 'Repetís los tests iniciales y comparás. En papel. Con números. Más peso. Más velocidad. Mejor recuperación. No es una sensación. Es evidencia. Y esa evidencia es el combustible que sostiene el proceso a largo plazo.'
  }, {
    num: '04',
    title: 'A los 12 meses',
    text: 'Sos un atleta notablemente más fuerte, más resistente y más completo que hace un año. No porque te mataste entrenando todos los días. Sino porque seguiste un sistema inteligente que hizo que cada semana construyera sobre la anterior.'
  }];
  return <section className="py-20 sm:py-32 px-4 bg-carbon-950 border-t border-carbon-800 blueprint-grid relative" data-id="element-252">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-253">
        <FadeIn data-id="element-254">
          <div className="flex items-center gap-4 mb-12" data-id="element-255">
            <span className="font-display text-4xl text-carbon-800" data-id="element-256">02</span>
            <div className="h-px bg-carbon-800 flex-grow" data-id="element-257" />
            <span className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-258">
              La Solución
            </span>
          </div>

          <h2 className="text-4xl sm:text-5xl md:text-6xl font-display text-white mb-16 uppercase tracking-wide leading-[1.1]" data-id="element-259">
            Existe una versión de tu entrenamiento{' '}
            <br className="hidden sm:block" data-id="element-260" />
            <span className="text-electric" data-id="element-261">
              que se ve completamente diferente.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-262">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-263">
              <div className="bg-carbon-950 border border-carbon-800 rounded-3xl p-6 sm:p-10 flex flex-col sm:flex-row gap-6 sm:gap-10 items-start group hover:bg-carbon-900 transition-colors" data-id="element-264">
                <div className="font-display text-5xl text-carbon-800 group-hover:text-electric transition-colors shrink-0 leading-none" data-id="element-265">
                  {step.num}
                </div>
                <div data-id="element-266">
                  <h3 className="text-2xl font-display text-white mb-3 uppercase tracking-wide" data-id="element-267">
                    {step.title}
                  </h3>
                  <p className="text-carbon-300 font-sans leading-relaxed" data-id="element-268">
                    {step.text}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-16 text-center border border-carbon-800 bg-carbon-900 rounded-3xl p-8 sm:p-12" data-id="element-269">
          <p className="text-2xl sm:text-3xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-270">
            Esa versión no requiere más horas de entrenamiento.
            <br data-id="element-271" />
            <span className="text-electric" data-id="element-272">Requiere el sistema correcto.</span>
          </p>
        </FadeIn>
      </div>
    </section>;
}